<template>
<div class="chapter">
<div class="inner_page">
<section class="preface" epub:type="preface">
<h2><span class="h2-inner">Publisher’s Note</span></h2>
<p class="firstInSection"><i>Family of the Empire</i> is set during the Boer War, and as such reflects offensive views and language common at the time. The author and publisher do not endorse or support these views or terms, but they are retained so as to preserve the integrity and power of the work.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter2.vue?6d03c653